import { Component, Input, Output, EventEmitter, Type } from '@angular/core';
import { PermissionService } from 'src/app/auth/services/permission.service';
import { AccessRequirement } from 'src/app/auth/types/access-level';
import { resolveOperationUpgradeIcon } from 'src/app/components/scrolling-list/services/batch-action-handler.service';

export interface MenuAction extends AccessRequirement {
  id: string;
  label: string;
  icon?: string;
  upgradeIcon?: string | (() => string | undefined);
  action?: () => void;
  disabled?: boolean;
}

export interface ActionsMenu {
  saveAction?: {
    id: string;
    label: string;
    action?: () => void;
    disabled: boolean | (() => boolean);
  } & AccessRequirement;
  cancelAction?: {
    id: string;
    label: string;
    action: () => void;
  };
  deleteAction?: MenuAction;
  moreOptions?: MenuAction[];
}

@Component({
  selector: 'common-actions',
  templateUrl: './common-actions.component.html',
  styleUrls: ['./common-actions.component.scss'],
  standalone: false,
})
export class CommonActionsComponent {
  constructor(private permissionService: PermissionService) {}

  private _title: string;

  @Input()
  get title(): string {
    return this._title;
  }
  set title(value: string) {
    this._title = value;
    this.titleChange.emit(value);
  }
  @Output() titleChange = new EventEmitter<string>();
  @Input() titleAriaLabel: string;

  @Input() actions: ActionsMenu;
  @Input() saving = false;
  @Input() changeDate?: Date;
  @Input() changedBy?: string;
  @Input() customComponent?: Type<any>;
  @Input() componentInputs?: { [key: string]: any };

  canShowAction(action: AccessRequirement): boolean {
    return this.permissionService.meetsAccessRequirement(action);
  }

  getUpgradeIcon(action: MenuAction): string | undefined {
    return resolveOperationUpgradeIcon(action.upgradeIcon);
  }

  hasVisibleMoreOptions(): boolean {
    const hasVisibleOption = this.actions?.moreOptions?.some(
      (action) => !action.disabled && this.canShowAction(action),
    );

    const hasVisibleDeleteAction =
      !!this.actions?.deleteAction &&
      !this.actions.deleteAction.disabled &&
      this.canShowAction(this.actions.deleteAction);

    return hasVisibleOption || hasVisibleDeleteAction;
  }
}
